module.exports = __webpack_public_path__ + "static/media/appstore-badge.61368901.png";